var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.mode === "dialog"
    ? _c(
        "dialog",
        {
          ref: "sapphireDialog",
          class: "sapphire-dialog modal-dialog " + _vm.modalDialogSize,
          attrs: {
            role: _vm.role,
            "aria-labelledby": _vm.dialogTitleId,
            "aria-describedby": _vm.dialogMessageId
          }
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c(
              "div",
              { staticClass: "modal-header" },
              [
                _vm._t(
                  "header",
                  [
                    _vm.type === "modal"
                      ? _c(
                          "button",
                          {
                            staticClass: "close",
                            attrs: {
                              type: "button",
                              "aria-label": "Close dialog"
                            },
                            on: {
                              click: function($event) {
                                return _vm.close(false)
                              }
                            }
                          },
                          [
                            _c("span", { attrs: { "aria-hidden": "true" } }, [
                              _vm._v("×")
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "h4",
                      {
                        staticClass: "modal-title",
                        attrs: { id: _vm.dialogTitleId }
                      },
                      [
                        _vm.type === "modal"
                          ? [_vm._v(_vm._s(_vm.modalTitle))]
                          : [_vm._v(_vm._s(_vm.title))]
                      ],
                      2
                    )
                  ],
                  { close: _vm.close }
                )
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-body", attrs: { id: _vm.dialogMessageId } },
              [
                _vm._t("hint"),
                _vm._v(" "),
                _vm._t("default", null, { close: _vm.close }),
                _vm._v(" "),
                _vm.type !== "modal"
                  ? _c("p", [_vm._v(_vm._s(_vm.message))])
                  : _vm._e()
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-footer" },
              [
                _vm._t(
                  "footer",
                  [
                    _vm.type === "modal"
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-default",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.close(false)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.closeText))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.type === "confirm"
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-default",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.close(false)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.cancelText))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.type !== "modal"
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.close(true)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.okText))]
                        )
                      : _vm._e()
                  ],
                  { close: _vm.close }
                )
              ],
              2
            )
          ])
        ]
      )
    : _vm.mode === "custom"
    ? _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm._show,
              expression: "_show"
            }
          ],
          class: ["modal-mask", { "modal-open": _vm._show }],
          attrs: { name: "modal" }
        },
        [
          _c(
            "div",
            {
              ref: "sapphireDialog",
              staticClass: "modal fade",
              class: { in: _vm._show },
              style: _vm.openStyles,
              attrs: {
                tabindex: "-1",
                role: _vm.role,
                "aria-labelledby": "dialogTitleId",
                "aria-describedby": _vm.dialogMessageId
              }
            },
            [
              _c(
                "div",
                {
                  class: "modal-dialog " + _vm.modalDialogSize,
                  attrs: { role: "document" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "modal-content",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "modal-header" },
                        [
                          _vm._t(
                            "header",
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "close",
                                  attrs: {
                                    type: "button",
                                    "aria-label": "Close"
                                  },
                                  on: { click: _vm.close }
                                },
                                [
                                  _c(
                                    "span",
                                    { attrs: { "aria-hidden": "true" } },
                                    [_vm._v("×")]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "h4",
                                {
                                  staticClass: "modal-title",
                                  attrs: { id: _vm.dialogTitleId }
                                },
                                [
                                  _vm.type === "modal"
                                    ? [_vm._v(_vm._s(_vm.modalTitle))]
                                    : [_vm._v(_vm._s(_vm.title))]
                                ],
                                2
                              )
                            ],
                            { close: _vm.close }
                          )
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "modal-body",
                          attrs: { id: _vm.dialogMessageId }
                        },
                        [
                          _vm._t("hint"),
                          _vm._v(" "),
                          _vm._t("default", null, {
                            close: _vm.close,
                            fields: _vm.fields
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "modal-footer" },
                        [
                          _vm._t(
                            "footer",
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-default",
                                  attrs: { type: "button" },
                                  on: { click: _vm.close }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(_vm.closeText) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            ],
                            { close: _vm.close }
                          )
                        ],
                        2
                      )
                    ]
                  )
                ]
              )
            ]
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }